var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatasetGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.294,
    height: 29.152,
    viewBox: "0 0 33.294 29.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(-196 -147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M33.222,13.01,17.784,5.676a.912.912,0,0,0-.779,0L1.57,13.01a.907.907,0,0,0,0,1.639l15.435,7.333a.908.908,0,0,0,.779,0L33.222,14.65a.907.907,0,0,0,0-1.639Z",
    transform: "translate(195.251 141.412)",
    fill: "#3f8627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M16.874,51.3a1.215,1.215,0,0,1-.52-.117L.919,43.849a1.21,1.21,0,1,1,1.039-2.186L16.873,48.75l14.919-7.087a1.21,1.21,0,1,1,1.038,2.186L17.393,51.183A1.216,1.216,0,0,1,16.874,51.3Z",
    transform: "translate(195.772 118.669)",
    fill: "#1a286d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M16.874,68.125a1.215,1.215,0,0,1-.52-.117L.919,60.675a1.211,1.211,0,0,1,1.039-2.187l14.915,7.086,14.92-7.086a1.211,1.211,0,0,1,1.039,2.187L17.393,68.008A1.211,1.211,0,0,1,16.874,68.125Z",
    transform: "translate(195.772 108.028)",
    fill: "#45539c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetGreen);
export default __webpack_public_path__ + "static/media/dataset-green.e6a2ce4c.svg";
export { ForwardRef as ReactComponent };